import React from "react";
import { useTranslation } from "react-i18next";
import Checkmark from "../../common/Checkmark";

const Introduction = () => {
  const { t } = useTranslation("home");

  return (
    <div className="space-y-4 text-left p-8 text-white">
      <div className="text-4xl">{t("intro.title")}</div>
      <p className="text-3xl">{t("intro.subTitle")}</p>
      <div className="flex items-center">
        <div className="mt-3 mb-3">{t("intro.briefIntro")}</div>
        <div className="ml-4 mt-3 mb-3 bg-emerald-600 rounded-br-2xl rounded-tl-2xl p-1">
          {t("intro.ageRequirement")}
        </div>
      </div>
      <ul className="space-y-4 mt-4">
        <li className="flex items-center">
          <Checkmark />
          <p className="ml-4">{t("intro.bulletPoint1")}</p>
        </li>
        <li className="flex items-center">
          <Checkmark />
          <p className="ml-4">{t("intro.bulletPoint2")}</p>
        </li>
        <li className="flex items-center">
          <Checkmark />
          <p className="ml-4">{t("intro.bulletPoint3")}</p>
        </li>
        <li className="flex items-center">
          <Checkmark />
          <p className="ml-4">{t("intro.bulletPoint4")}</p>
        </li>
        <li className="flex items-center">
          <Checkmark />
          <p className="ml-4">{t("intro.bulletPoint5")}</p>
        </li>
      </ul>
    </div>
  );
};

export default Introduction;
